const hex = (color: number) => {
  const colorString = color.toString(16)
  return colorString.length === 1 ? `0${colorString}` : colorString
}

export default function interpolateColor({
  color1,
  color2,
  ratio,
}: {
  color1: string
  color2: string
  ratio: number
}): string {
  const r = Math.ceil(
    Number.parseInt(color2.substring(1, 3), 16) * ratio +
      Number.parseInt(color1.substring(1, 3), 16) * (1 - ratio)
  )
  const g = Math.ceil(
    Number.parseInt(color2.substring(3, 5), 16) * ratio +
      Number.parseInt(color1.substring(3, 5), 16) * (1 - ratio)
  )
  const b = Math.ceil(
    Number.parseInt(color2.substring(5, 7), 16) * ratio +
      Number.parseInt(color1.substring(5, 7), 16) * (1 - ratio)
  )

  return `#${hex(r)}${hex(g)}${hex(b)}`
}
